import classNames from "classnames";
import {renderIf, renderIfElse} from "../../../Shared";
import {HeaderWithIconLine} from "../../Templates/items/ListHeader";
import _ from "lodash";
import {SacramentTypes} from "../consts/SacramentTypes";
import React, {useContext} from "react";
import useTranslate from "../../../../modules/local/useTranslate";
import {GoDotFill} from "react-icons/go";
import Translate from "../../../../modules/local/Translate";
import {Avatar} from "antd";
import {RiUser2Fill} from "react-icons/ri";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {LayoutContext} from "../../../../components/layouts/Default/LayoutContext";
import getLabelOfGender from "../../../../helpers/getLabelOfGender";
import {PiLinkSimpleBold} from "react-icons/pi";
import getAliasName from "../../../../helpers/getAliasName";
import {formatDate} from "../../../../helpers/datetimeHelpers";
import {ItemInformation} from "../../../../components/common/ItemInformation";
import {DoubleValueItem} from "../../../../components/common/DoubleValueItem";
import {DatePlaceItem} from "../../../../components/common/DatePlaceItem";


export const SacramentItem = ({item}) => {
    const t = useTranslate();
    const {source_idcode, church_name, sacrament_type, eff_date, parish, officiant_name, participant_name} = item ?? {}

    return (
        <div className="flex flex-col gap-1">
            <HeaderWithIconLine
                icon={_.find(SacramentTypes, {value: sacrament_type})?.icon}
                lineColor="border-blue-200"
                title={_.find(SacramentTypes, {value: sacrament_type})?.label}
                className="mt-2 text-sm text-blue-500"
            />
            <div className="ml-1 space-y-1">
                <DatePlaceItem
                    showIcon={true}
                    className="text-xs italic"
                    label={sacrament_type === 'matrimony' ? t('date of celebration') : `${t('date')} ${t(sacrament_type)}`}
                    date={formatDate(eff_date, 'DD/MM/YYYY')}
                    place={church_name}
                />
                {renderIf(
                    _.some([parish, source_idcode]),
                    <DoubleValueItem
                        showIcon={true}
                        className="text-xs italic"
                        labelFirst="belong to"
                        valueFirst={parish?.fullname}
                        labelSecond={`${t('book {n} code', {n: <span>{t(sacrament_type)}</span>})} : `}
                        valueSecond={source_idcode}
                    />
                )}
                {renderIf(
                    officiant_name,
                    <div className="space-x-1 text-xs italic">
                        <GoDotFill size={10} className="text-color-500"/>
                        <span className="text-color-500 italic whitespace-no-wrap">
                            {`${t('by_prelate')} : `}
                        </span>
                        <span className="font-semibold text-color-100">
                            {officiant_name}
                        </span>
                        <span className="text-color-500 italic whitespace-no-wrap">
                            {`${t("celebrate")}.`}
                        </span>
                    </div>
                )}
                {renderIf(
                    participant_name,
                    <ItemInformation
                        showIcon={true}
                        label={sacrament_type === 'matrimony' ? 'marriage witnesses' : 'godparent'}
                        value={participant_name}
                        className="text-xs italic"
                    />
                )}
            </div>
        </div>
    )
}

export const ChildrenMemberItemInfo = ({index, item}) => {
    const {isSm} = useContext(LayoutContext)
    const t = useTranslate()
    const {avatar, patron_saint_name, name, birth_date, birth_province_name, gender, member_user} = item ?? {}

    return (
        <div className="flex items-center gap-2">
            {renderIf(
                !isSm,
                <Avatar
                    size={40}
                    src={avatar}
                    icon={<RiUser2Fill size={20} className="text-color-500"/>}
                    className="flex flex-center background-200"
                />
            )}
            <div className="flex flex-col flex-1">
                <div className="flex items-baseline gap-x-2">
                    <span className="text-xs text-color-500 italic">
                        {`${t('child')} ${index + 1} : `}
                    </span>
                    {renderIfElse(
                        member_user,
                        <Link to={getLinkToDetail(member_user)} className="font-bold text-primary-500 no-underline">
                            {getAliasName(item, 'patron_saint') || ''}{` ${name}`}
                            <PiLinkSimpleBold size={10}/>
                        </Link>,
                        <span className="font-bold text-color-000">
                            {getAliasName(item, 'patron_saint') || ''}
                            {` ${name}`}
                        </span>
                    )}
                </div>
                <div className="flex items-center gap-x-4 md:gap-x-6">
                    <DatePlaceItem
                        showIcon={true}
                        label="date of birth"
                        date={birth_date ? formatDate(birth_date, 'DD/MM/YYYY') : t('not update')}
                        place={birth_province_name}
                        className="text-xs leading-snug"
                    />
                    {renderIf(
                        gender !== 0,
                        <ItemInformation
                            showIcon={true}
                            label=""
                            value={t(getLabelOfGender(gender))}
                            className="text-xs leading-snug italic"
                        />
                    )}
                </div>
            </div>
        </div>
    )
}

export const ParentMemberItemInfo = ({item, className}) => {
    const t = useTranslate()
    const {patron_saint_name, name, birth_date, birth_province_name, father_name, mother_name, member_user} = item ?? {}

    return (
        <div className={classNames('flex flex-col gap-1 flex-center', className)}>
            {renderIfElse(
                name,
                <div className="text-center font-bold text-lg text-color-000 leading-snug">
                    {getAliasName(item, 'patron_saint') || ''}{` ${name}`}
                </div>,
                <Link to={getLinkToDetail(member_user)}
                      className="text-center font-bold text-lg text-primary-500 leading-snug no-underline">
                    {getAliasName(item, 'patron_saint') || ''} ${member_user?.name}`} <PiLinkSimpleBold size={12}/>
                </Link>
            )}
            <DatePlaceItem
                label="date of birth"
                date={birth_date ? formatDate(birth_date, 'DD/MM/YYYY') : t('not update')}
                place={birth_province_name}
                className="text-sm leading-snug"
            />
            <ItemInformation label="father" value={father_name} className="text-sm leading-snug"/>
            <ItemInformation label="mother" value={mother_name} className="text-sm leading-snug"/>
        </div>
    )
}

export const SacramentHeader = ({label, onClick, expanded = false, extraAction}) => (
    <Translate>
        {(t) => (
            <div className="flex items-center gap-2">
                <HeaderWithIconLine
                    icon={<GoDotFill size={14} className="text-blue-300"/>}
                    title={label}
                    lineColor="border-blue-100"
                    className="flex-1 text-blue-500"
                />
                {extraAction}
                <span
                    onClick={onClick}
                    style={{padding: '0 10px', borderRadius: 5, height: 24}}
                    className={classNames(
                        "flex flex-center text-xs leading-tight cursor-pointer",
                        expanded ? 'background-200 hover:bg-blue-100 text-color-300 hover:text-blue-500 italic'
                            : 'font-medium bg-blue-100 hover:bg-blue-100 text-blue-500'
                    )}>
                    {expanded ? t('see less') : t('input')}
                </span>
            </div>
        )}
    </Translate>
)